<div class="flex w-full flex-col space-y-4 px-2 py-4">
  <div class="">
    <h2 class="text-xl font-medium text-surface-700 dark:text-surface-200">
      {{ texts.switchAccountHeader }}
    </h2>
    <p class="text-surface-500">{{ texts.switchAccountDescription }}</p>
  </div>
  <form [formGroup]="formGroup">
    @if (connections()?.length && user(); as user) {
      <p-list-box
        class="w-full dark:border-surface-700"
        [autoOptionFocus]="true"
        [filter]="true"
        [filterFields]="['name', 'customerId']"
        [options]="connections() ?? []"
        #listbox
        formControlName="connection"
        scrollHeight="170px"
      >
        <ng-template
          #item
          let-customer
        >
          <div class="flex items-center gap-2 overflow-hidden max-w-[240px]">
            <div class="truncate">{{ customer.name }}</div>
          </div>
        </ng-template>
      </p-list-box>
    } @else {
      <p-skeleton
        height="16rem"
        width="100%"
      ></p-skeleton>
    }
  </form>
</div>
